<template>
  <div :id="quesData.answerId" class="upload-type-wrapper">
    <div v-if="quesData.optionTitle" :class="['upload-title', {'is-detail': isDetail}]">
      {{ quesData.optionTitle }}
      <span v-if="quesData.answerType === 2 && !isDetail" class="not-require">（选填） </span>
    </div>
    <div v-if="!riskPic && isDetail" class="no-risk"></div>
    <van-uploader
      v-else-if="!(isDetail && !fileList.length)"
      v-model="fileList"
      multiple
      accept="image/png,image/jpg,image/jpeg"
      :max-count="max"
      :upload-text="tips"
      :readonly="isDetail"
      :show-upload="!isDetail"
      :deletable="!isDetail"
      :before-read="onBeforeRead"
      :after-read="onAfterRead"
      @delete="onDelete"/>
  </div>
</template>

<script>
import _ from 'lodash';
import { obsUpload } from '@/api/obsajax';
import { Uploader, Toast } from 'vant';
import Audit from '@/assets/crf/audit.svg';

export default {
  name: 'UploadType',
  props: {
    value: {
      type: Object,
      default() {}
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    riskPic: {
      type: Boolean,
      default: false
    }
  },
  comments: {
    vanUploader: Uploader,
  },
  data() {
    return {
      quesData: this.value,
      message: '',
      fileList: [],
      max: 10,
      uploading: false,
    };
  },
  watch: {
    'value.memberAnswerPicList'(list) {
      this.$set(this.quesData, 'memberAnswerPicList', list)
      this.initFileList();
    },
    uploading(val) {
      this.$emit('uploading', val);
    }
  },
  created() {
    this.initFileList();
  },
  computed: {
    count() {
      return this.max - this.fileList.length;
    },
    tips() {
      const num = this.max - (this.fileList?.length || 0)
      return !this.fileList?.length ? '添加照片' : ('可再加' + num + '张')
    }
  },
  methods: {
    initFileList() {
      this.fileList = (this.quesData.memberAnswerPicList || [])?.map(item => {
        return {
          url: item.riskResult === 1 ? Audit : item.picUrl,
        };
      });
    },
    onDelete(file, detail) {
      this.quesData.memberAnswerPicList.splice(detail.index, 1);
    },
    onBeforeRead() {
      this.uploading = true;
      return true;
    },
    uploadFile(fileProxy, allFileProxys) {
      fileProxy.status = 'uploading';
      fileProxy.message = '正在上传...';

      const options = {
        file: fileProxy.file,
        onProgress: (progress) => {},
      };

      obsUpload(options).then(res => {
        fileProxy.status = 'success';
        fileProxy.message = '';
        fileProxy.url = res.filePath;
        if (!this.quesData.memberAnswerPicList) {
          this.quesData.memberAnswerPicList = [];
        }
        this.quesData.memberAnswerPicList.push({
          answerId: this.quesData.answerId,
          picUrl: res.filePath,
        });
        this.$emit('input', this.quesData);
      }).catch(err => {
        fileProxy.status = 'failed';
        fileProxy.message = '上传失败';
        this.$toast('上传失败');
      }).finally(() => {
        fileProxy.uploaded = 'done';
        if (!allFileProxys || allFileProxys.filter(item => item.uploaded === 'done')?.length === allFileProxys?.length) {
          this.uploading = false;
        }
      });
    },
    onAfterRead(fileProxys) {
      if (Array.isArray(fileProxys)) {
        fileProxys.map(fileProxy => {
          this.uploadFile(fileProxy, fileProxys);
        });
      } else {
        this.uploadFile(fileProxys);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.upload-type-wrapper {
  .upload-title {
    margin: 0 0 16px 0;
    font-size: 24px;
    line-height: 32px;
    color: #666;
    &.is-detail {
      color: #ACACAC;
    }
  }
  .not-require {
    margin-left: 10px;
    font-weight: 400;
    line-height: 32px;
    font-size: 24px;
    color: #999;
  }
  .no-risk {
    width: 100%;
    height: 152px;
    background: url(../../../../assets/crf/no-control-icon.svg) no-repeat;
    background-size: contain;
  }
  :deep(.van-uploader__upload) {
    border-radius: 18px;
  }
  :deep(.van-icon-photograph) {
    background: url(../../../../assets/crf/photograph.svg) no-repeat;
    width: 40px;
    height: 40px;
    background-size: contain;
    &:before {
      content: '';
    }
  }
  :deep(.van-uploader__upload) {
    width: 152px;
    height: 152px;
    background: #fff;
    border: 1px dashed rgba(172,172,172,0.6);
  }
  :deep(.van-uploader__preview) {
    margin: 0 13px 13px 0;
  }
  :deep(.van-uploader__preview-image) {
    border-radius: 18px;
    width: 152px;
    height: 152px;
  }
  :deep(.van-uploader__mask) {
    border-radius: 18px;
  }
  :deep(.van-uploader__preview-delete) {
    top: -10px;
    right: -10px;
    border-radius: 24px;
    background-color: unset;
    width: 32px;
    height: 32px;
  }
  :deep(.van-uploader__preview-delete-icon) {
    background: url(../../../../assets/crf/delete-icon.svg) no-repeat;
    width: 64px;
    height: 64px;
    background-size: 100% 100%;
    &:before {
      content: '';
    }
  }
  :deep(.van-uploader__upload-text) {
    color: #5E5E5E;
  }
}
</style>

<style>
.van-image-preview__index {
  top: unset;
  bottom: 26px;
}
</style>
